var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheckSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 7,
  viewBox: "0 0 8 7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.00494 6.43268C2.74494 6.43268 2.49494 6.33268 2.29494 6.14268L0.294941 4.14268C-0.0950586 3.75268 -0.0950586 3.12268 0.294941 2.73268C0.684941 2.34268 1.31494 2.34268 1.70494 2.73268L2.99494 4.02268L6.29494 0.722676C6.68494 0.332676 7.31494 0.332676 7.70494 0.722676C8.09494 1.11268 8.09494 1.74268 7.70494 2.13268L3.71494 6.14268C3.51494 6.34268 3.26494 6.43268 3.00494 6.43268Z",
  fill: "white"
})));
export default SvgIconCheckSmall;